<mat-dialog-content class="mat-body-1"> This is a dialog </mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>Okay</button>
</mat-dialog-actions>
